// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__5lSTk","alertIcon":"ConfirmModal_alertIcon__ggcfz"};